import CapturePassport from "@/modules/passport/pages/CapturePassport.vue";
export default [
  {
    path: "/document/passport",
    name: "capturePassport",
    component: CapturePassport,
  },
];
